// src/utils/resourceEnvironment.js
import app from 'configs/appResolver';
import { AVAILABLE_RESOURCES } from 'constants/Resources';

/**
 * Filter subscription resources removing UIDs not available in the current environment.
 * A resource is allowed only if its `availability` map includes the current app ID
 * with the current environment listed.
 * Resources without matching availability are treated as disabled/removed.
 */
export function filterResourcesByEnvironment(resourceUids) {
  if (!resourceUids?.length) return resourceUids || [];

  const currentEnv = app.HOMOLOGATION_MODE ? 'homologation' : 'production';

  // Build a set of UIDs that are fully available in the current app + environment
  const allowed = new Set();
  for (const r of AVAILABLE_RESOURCES) {
    if (r.availability?.[app.ID]?.includes(currentEnv)) {
      allowed.add(r.uid);
    }
  }

  return resourceUids.filter(uid => allowed.has(uid));
}
